import { config } from "@fortawesome/fontawesome-svg-core";
import axios from "axios";
import moment from "moment";
import { data } from "react-router-dom";
import connector from "../connector/connector";

let utilities = {
    capitalizeFirstLetter: (string) => {
        if (typeof string !== 'string') return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getCityStateFromLatLong: (lat, long) => {
        if (typeof lat !== 'number' || typeof long !== 'number') return '';
        // This is a placeholder for actual implementation
        // In a real application, you would use an API to get the city and state from latitude and longitude
        console.log('API key: ', process.env.REACT_APP_GEOCODING_API_KEY);
        axios.get(`https://geocode.maps.co/reverse?lat=${lat}&lon=${long}&api_key=${process.env.REACT_APP_GEOCODING_API_KEY}`)
            .then(response => {
                if (response.data && response.data.address) {
                    const { city, state } = response.data.address;
                    return `${city}, ${state}`;
                }
                return '';
            })
            .then(response => {
                if (response.data && response.data.address) {
                    const { city, state } = response.data.address;
                    return `${city}, ${state}`;
                }
                return '';
            })
            .catch(error => {
                console.error('Error fetching city and state:', error);
                return '';
            });
    },
    assessmentCategories: ['policy', 'people', 'technology', 'opportunities'],
    returnNextCategory: (currentCategory) => {
        const categories = utilities.assessmentCategories;
        const currentIndex = categories.indexOf(currentCategory);
        if (currentIndex === -1 || currentIndex === categories.length - 1) {
            return null; // No next category
        }
        return categories[currentIndex + 1];
    },
    // getAnsweredQuestionsCount: () => {
    //     let count = 0;
    //     for (let key in localStorage) {
    //         // const key = localStorage.key(i);
    //         if (key.startsWith('questions.AIRQ-') && !key.endsWith('-followUp')) {
    //             if(JSON.parse(localStorage.getItem(key)).length === 0) {
    //                 continue;
    //             } else {
    //                 count++;
    //             }
    //         }
    //     }
    //     return count;
    // },
    getAnsweredQuestionsCount: () => {
        let count = 0;

        try {
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);

                // Skip null or unrelated keys
                if (!key || !key.startsWith('questions.AIRQ-') || key.endsWith('-followUp')) {
                    continue;
                }

                const item = localStorage.getItem(key);

                if (!item) continue;

                let parsed;
                try {
                    parsed = JSON.parse(item);
                } catch (err) {
                    console.warn(`Invalid JSON in localStorage at key "${key}"`, err);
                    continue;
                }

                // Count if answer is non-empty
                if (
                    (Array.isArray(parsed) && parsed.length > 0) ||
                    (typeof parsed === 'string' && parsed.trim() !== '') ||
                    (typeof parsed === 'object' && parsed !== null && Object.keys(parsed).length > 0)
                ) {
                    count++;
                }
            }
        } catch (e) {
            console.warn('Could not access localStorage in Safari (possibly private mode):', e);
            return 0;
        }

        return count;
    },

    getAnsweredQuestions: () => {
        let holder = [];
        for (let key in localStorage) {
            if (key.startsWith('questions.AIRQ-') && !key.endsWith('-followUp')) {
                holder.push(localStorage[key])
            }
        }
        return holder;
    },

    getFullSurveyResponses: () => {
        const holder = [];

        // First loop: collect all base questions (excluding follow-ups)
        for (let key in localStorage) {
            let extractedId = key.split('-')[1];
            // console.log(exteactedId)
            let additional = localStorage.getItem(`questions.FOLLOWUP-${extractedId}`) || null
            if (key.startsWith('questions.AIRQ-') && !key.endsWith('-followUp')) {
                const parsedVal = JSON.parse(localStorage[key]);

                const answerObj = {
                    questionId: key.replace('questions.AIRQ-', ''),
                    answers: Array.isArray(parsedVal) ? parsedVal : [parsedVal],
                    followUpAnswer: additional ? additional : null,
                    timeStamp: localStorage.getItem(`questions.TIMESTAMP-${extractedId}`) || null
                };

                holder.push(answerObj);
            }
        }


        return holder;
    },


    getSavedAnswersIds: () => {
        let holder = [];
        for (let key in localStorage) {
            if (key.startsWith('questions.AIRQ-') && !key.endsWith('-followUp')) {
                let parsedVal = JSON.parse(localStorage[key])
                if (Array.isArray(parsedVal)) {
                    parsedVal.forEach(id => holder.push(id))
                } else {
                    holder.push(parsedVal)
                }
            }
        }
        return holder;
    },
    returnPreviousCategory: (currentCategory) => {
        const categories = utilities.assessmentCategories;
        const currentIndex = categories.indexOf(currentCategory);
        if (currentIndex <= 0) {
            return null; // No previous category
        }
        return categories[currentIndex - 1];
    },
    isValidEmail: (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    },
    translateLanguge: (text) => {
        // translate(text, { to: localStorage.getItem('language') || 'en' })
        //     .then(res => {
        //         return res.text;
        //     })
        //     .catch(err => {
        //         console.error('Translation error:', err);
        //         return text; // Fallback to original text if translation fails
        //     }
        // );
    },
    calculatePercentage: (value, max) => {
        if (max === 0) return 0;
        return ((value / max) * 100).toFixed(0);
      },
    convertdateTimeToReadable: (dateTimeString) => {

        const date = new Date(dateTimeString);

        const humanReadable = date.toLocaleString(); // uses your system's locale
        return humanReadable;
    },
    isdateOlderThan30Minutes: (dateTimeString) => {
        const date = new Date(dateTimeString);
        const now = new Date();
        const diffInMs = now - date;
        const diffInMinutes = diffInMs / (1000 * 60);
        return diffInMinutes > 30;
    },
    averageTimeBetweenResponses: (responses) => {
        if (!responses || responses.length < 2) return 0; // Not enough data to calculate

        // Sort by timestamp ascending
        const sorted = responses.slice().sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp));

        // Calculate differences in milliseconds
        const diffs = [];
        for (let i = 1; i < sorted.length; i++) {
            const prevTime = new Date(sorted[i - 1].timeStamp).getTime();
            const currTime = new Date(sorted[i].timeStamp).getTime();
            diffs.push(currTime - prevTime);
        }

        // Calculate average
        const avgMs = diffs.reduce((sum, val) => sum + val, 0) / diffs.length;

        // return avgMs

        const duraation = moment.duration(avgMs);
        const hours = Math.floor(duraation.asHours());
        const minutes = Math.floor(duraation.asMinutes()) % 60;
        const seconds = Math.floor(duraation.asSeconds()) % 60;

        console.log('millis', avgMs);

        return moment.utc(avgMs).format("HH:mm:ss");
    },
    totalTimeBetweenResponses: (responses) => {
        if (!responses || responses.length < 2) return 0; // Not enough data to calculate

        // Sort by timestamp ascending
        const sorted = responses.slice().sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp));

        // Calculate total time in milliseconds
        const firstTime = new Date(sorted[0].timeStamp).getTime();
        const lastTime = new Date(sorted[sorted.length - 1].timeStamp).getTime();
        const totalMs = lastTime - firstTime;

        // Convert to human-readable format
        const duration = moment.duration(totalMs);
        return moment.utc(totalMs).format("HH:mm:ss");
    },

    // function to get the browser name and version and the device type
    getBrowserInfo: () => {
        const userAgent = navigator.userAgent;
        let browserName, fullVersion, deviceType;

        // Detect browser name and version
        if (userAgent.indexOf("Firefox") > -1) {
            browserName = "Firefox";
            fullVersion = userAgent.split("Firefox/")[1].split(" ")[0];
        } else if (userAgent.indexOf("Chrome") > -1) {
            browserName = "Chrome";
            fullVersion = userAgent.split("Chrome/")[1].split(" ")[0];
        } else if (userAgent.indexOf("Safari") > -1) {
            browserName = "Safari";
            fullVersion = userAgent.split("Version/")[1].split(" ")[0];
        } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
            browserName = "Internet Explorer";
            fullVersion = userAgent.indexOf("MSIE") > -1 ? userAgent.split("MSIE ")[1].split(";")[0] : userAgent.split("rv:")[1].split(")")[0];
        } else {
            browserName = "Unknown";
            fullVersion = "Unknown";
        }

        // Detect device type
        if (/Mobi|Android/i.test(userAgent)) {
            deviceType = "Mobile";
        } else if (/Tablet|iPad/i.test(userAgent)) {
            deviceType = "Tablet";
        } else {
            deviceType = "Desktop";
        }



        return {
            browserName: browserName,
            fullVersion: fullVersion,
            deviceType: deviceType
        };
    },

    getWeightedScores: (assessments) => {
        let totals = {
            People: 0,
            Policy: 0,
            Technology: 0,
            total: 0
        }

        let averages = {
            People: 0,
            Policy: 0,
            Technology: 0,
            total: 0
        }

        let weightedAssessments = assessments.filter(val => val.fields['Weighted'] === "true");

        totals.people = weightedAssessments.reduce((acc, assessment) => {
            return acc + (assessment.fields['People Score'] || 0);
        }, 0);
        totals.policy = weightedAssessments.reduce((acc, assessment) => {
            return acc + (assessment.fields['Policy Score'] || 0);
        }, 0);
        totals.technology = weightedAssessments.reduce((acc, assessment) => {
            return acc + (assessment.fields['Technology Score'] || 0);
        }, 0);
        totals.total = weightedAssessments.reduce((acc, assessment) => {
            return acc + (assessment.fields['Total Score'] || 0);
        }, 0);



        averages.people = totals.people / weightedAssessments.length;
        averages.policy = totals.policy / weightedAssessments.length;
        averages.technology = totals.technology / weightedAssessments.length;
        averages.total = totals.total / weightedAssessments.length;

        return {
            totals: totals,
            averages: averages
        };
    },

    cleanupLocalStorage: () => {
        for (let key in localStorage) {
            if (key.startsWith('questions.AIRQ-') || key.startsWith('questions.TIMESTAMP-') || key.startsWith('questions.FOLLOWUP-')) {
              
                    localStorage.removeItem(key);
                
            }
        }
        localStorage.removeItem('shownMilestones');
    },

    countTotalPoints: (data) => {   
        if(!data || data.length === 0) return 0;
        let total = 0;
        data.forEach(response => {
            if(response.category !== 'Opportunities') {
                total += response.answers.reduce((sum, item) => sum + item.points, 0);
            }
        });
        return total;
    },

    updateOrAddEmailToAssessment: async (assessmentId, email) => {
       await connector.addEmailToAssessment(assessmentId, email)
            .then(response => {
                // console.log('Email updated or added successfully:', response);
            })
            .catch(error => {
                console.error('Error updating or adding email:', error);
            }
            );
    },

    calculateTrend: (current, previous) => {
        console.log('calculateTrend', { current, previous });
        let returnObject = {};
        if (previous === current) {
            returnObject.trend = 'stable';
        }
        else if (previous > current) {
            returnObject.trend = 'down';
            returnObject.difference = this.calculatePercentage(previous - current, previous);
        }
        else if (previous < current) {
            returnObject.trend = 'up';
            returnObject.difference = this.calculatePercentage(current - previous, previous);
        }
        return returnObject;
    },
    


    questionCount: 0

}

export default utilities;